import percentageIcon from "../../assets/icons/Minus-icon.svg";
import { useState, useEffect, useRef } from "react";

export default function FeatureTable() {
  const [showTooltips, setShowTooltips] = useState<boolean[]>([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const tooltipRefs = useRef<Array<HTMLDivElement | null>>([]);

  useEffect(() => {
    const closeTooltipOnClickOutside = (event: MouseEvent) => {
      // Check if the click target is outside any tooltip
      const isClickOutsideTooltip = tooltipRefs.current.every(
        (tooltipRef) =>
          tooltipRef &&
          event.target instanceof Node &&
          !tooltipRef.contains(event.target)
      );

      if (isClickOutsideTooltip) {
        // Close all tooltips
        setShowTooltips(showTooltips.map(() => false));
      }
    };

    // Add click event listener to the document body
    document.body.addEventListener("click", closeTooltipOnClickOutside);

    return () => {
      // Remove the event listener when the component unmounts
      document.body.removeEventListener("click", closeTooltipOnClickOutside);
    };
  }, [showTooltips]);

  const toggleTooltip = (index: number, event: React.MouseEvent) => {
    // Prevent the click event from propagating to the document body
    event.stopPropagation();

    const updatedTooltips = showTooltips.map((_, i) =>
      i === index ? !showTooltips[index] : false
    );
    setShowTooltips(updatedTooltips);
  };

  return (
    <div className="relative mb-20 md:mb-40 mt-20 md:mt-40 mx-auto container sm:rounded-lg">
      <table className="w-full text-[16px] text-left rtl:text-right text-gray-700">
        <thead className="text-doctio-dark">
          <tr>
            <th scope="col" className="md:px-6 py-3">
              <h2 className="text-doctio-dark text-left w-[235px] hidden md:block mx-auto md:text-dxl">
                Funktion
              </h2>
            </th>

            <th scope="col" className="md:px-6 py-3">
              <h2 className="text-doctio-dark text-center mr-5 md:mr-0 md:text-dxl">
                <span className="hidden md:inline mr-2">Doctio</span>
                Basic
              </h2>
            </th>
            <th scope="col" className="md:px-6 py-3">
              <h2 className="text-doctio-dark text-center md:text-dxl">
                <span className="hidden md:inline mr-2">Doctio</span>
                <span>Pro</span>
              </h2>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className="odd:bg-white even:bg-[#f8fbf9] rounded">
            <th
              scope="row"
              className="md:px-6 py-4 font-medium flex w-full md:w-[265px] justify-between relative mx-auto text-[16px] md:text-dbase text-doctio-dark whitespace-nowrap w-full"
            >
              Klikfraser
              <div
                className={`tooltip-content ${
                  showTooltips[0] ? "" : "hidden"
                } absolute md:right-[-44.5rem] z-50 overflow-wrap break-word whitespace-normal h-fit text-doctio-dark w-[calc(100vw-29px)] md:w-[435px] rounded-2xl top-[35px] md:top-0 bg-white p-2 shadow-md border border-gray-300`}
              >
                <p className="m-0">
                  Klikfraser er fraser der kan indeholde klikelementer som
                  f.eks, tjekbokse, single- og multivalg dropdown menuer,
                  tekstfelter, talfelter, inline noter i fraserne samt vis-skjul
                  elementer.{" "}
                </p>
              </div>
              <svg
                fill="#415779"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20.2 20.2"
                onClick={(e) => toggleTooltip(0, e)}
                className="info-boks cursor-pointer mr-4 md:mr-0"
                width="20px"
                height="20px"
              >
                <g id="Info-icon" transform="translate(0.1 0.1)">
                  <path
                    id="Icon_metro-info"
                    data-name="Icon metro-info"
                    d="M11.321,7.866a.94.94,0,0,1,.938-.937h.625a.94.94,0,0,1,.937.938v.625a.94.94,0,0,1-.937.938h-.625a.94.94,0,0,1-.938-.937Zm3.75,9.063h-5v-1.25h1.25v-3.75h-1.25v-1.25h3.75v5h1.25Zm-2.5-15a10,10,0,1,0,10,10,10,10,0,0,0-10-10Zm0,18.125A8.125,8.125,0,1,1,20.7,11.928,8.125,8.125,0,0,1,12.571,20.053Z"
                    transform="translate(-2.571 -1.928)"
                    fill="#415779"
                    stroke="#fff"
                    stroke-width="0.2"
                  />
                </g>{" "}
              </svg>
            </th>

            <td className="md:px-6 py-4">
              <img
                src={percentageIcon}
                width={15}
                className="ml-5 mr-4 md:mx-auto"
                alt="percentage icon"
              />
            </td>
            <td className="md:px-6 py-4">
              <svg
                className="ml-5 mr-4 md:mx-auto"
                fill="#1f7672"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22.476 20"
                width="18px"
                height="18px"
              >
                <g id="Group_2813" data-name="Group 2813">
                  <path
                    id="Path_8102"
                    data-name="Path 8102"
                    d="M25.488,8.983l-9.443,12.49L11.973,16.2a2.5,2.5,0,1,0-3.947,3.073l6.07,7.769a2.506,2.506,0,0,0,3.947-.025L29.46,12.031a2.513,2.513,0,1,0-4-3.048Z"
                    transform="translate(-7.499 -7.994)"
                    fill="#1f7672"
                  />
                </g>{" "}
              </svg>
            </td>
          </tr>
          <tr className="odd:bg-white even:bg-[#f8fbf9] rounded-lg">
            <th
              scope="row"
              className="md:px-6 py-4 rounded-lg font-medium flex w-full md:w-[265px] justify-between relative mx-auto text-[16px] md:text-dbase text-doctio-dark whitespace-nowrap w-full"
            >
              DoctioAssist
              <div
                className={`tooltip-content ${
                  showTooltips[1] ? "" : "hidden"
                } absolute md:right-[-44.5rem] z-50 overflow-wrap break-word whitespace-normal h-fit text-doctio-dark w-[calc(100vw-29px)] md:w-[435px] rounded-2xl top-[35px] md:top-0 bg-white p-2 shadow-md border border-gray-300`}
              >
                <p className="m-0">
                  DoctioAssist er en smartfunktion der tillader indsættelse af
                  fraser eller dele af fraser, mens man arbejder i en frase.
                  Dette gøres via en hotkey funktion ("punktum") efterfulgte af
                  navnet på frasen.
                </p>
              </div>
              <svg
                fill="#415779"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20.2 20.2"
                className="info-boks cursor-pointer mr-4 md:mr-0"
                onClick={(e) => toggleTooltip(1, e)}
                width="20px"
                height="20px"
              >
                <g id="Info-icon" transform="translate(0.1 0.1)">
                  <path
                    id="Icon_metro-info"
                    data-name="Icon metro-info"
                    d="M11.321,7.866a.94.94,0,0,1,.938-.937h.625a.94.94,0,0,1,.937.938v.625a.94.94,0,0,1-.937.938h-.625a.94.94,0,0,1-.938-.937Zm3.75,9.063h-5v-1.25h1.25v-3.75h-1.25v-1.25h3.75v5h1.25Zm-2.5-15a10,10,0,1,0,10,10,10,10,0,0,0-10-10Zm0,18.125A8.125,8.125,0,1,1,20.7,11.928,8.125,8.125,0,0,1,12.571,20.053Z"
                    transform="translate(-2.571 -1.928)"
                    fill="#415779"
                    stroke="#fff"
                    stroke-width="0.2"
                  />
                </g>{" "}
              </svg>
            </th>

            <td className="md:px-6 py-4">
              <img
                src={percentageIcon}
                className="ml-5 mr-4 md:mx-auto"
                width={15}
                alt="percentage icon"
              />
            </td>
            <td className="md:px-6 py-4">
              <svg
                className="ml-5 mr-4 md:mx-auto"
                fill="#1f7672"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22.476 20"
                width="18px"
                height="18px"
              >
                <g id="Group_2813" data-name="Group 2813">
                  <path
                    id="Path_8102"
                    data-name="Path 8102"
                    d="M25.488,8.983l-9.443,12.49L11.973,16.2a2.5,2.5,0,1,0-3.947,3.073l6.07,7.769a2.506,2.506,0,0,0,3.947-.025L29.46,12.031a2.513,2.513,0,1,0-4-3.048Z"
                    transform="translate(-7.499 -7.994)"
                    fill="#1f7672"
                  />
                </g>{" "}
              </svg>
            </td>
          </tr>
          <tr className="odd:bg-white even:bg-[#f8fbf9] rounded">
            <th
              scope="row"
              className="md:px-6 py-4 font-medium flex w-full md:w-[265px] justify-between relative mx-auto text-[16px] md:text-dbase text-doctio-dark whitespace-nowrap w-full"
            >
              Medarbejder adminstration
              <div
                className={`tooltip-content ${
                  showTooltips[2] ? "" : "hidden"
                } absolute md:right-[-44.5rem] z-50 overflow-wrap break-word whitespace-normal h-fit text-doctio-dark w-[calc(100vw-29px)] md:w-[435px] rounded-2xl top-[35px] md:top-0 bg-white p-2 shadow-md border border-gray-300`}
              >
                <p className="m-0">
                  Med medarbejder adminstration har du foruden mulighed for at
                  dele fraser med dine kolleager, også mulighed for at tildele
                  forskellige brugerrettigheder til delte fraser. F.eks.
                  læserettighed eller adminstratorrettighed.{" "}
                </p>
              </div>
              <svg
                fill="#415779"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20.2 20.2"
                className="info-boks cursor-pointer mr-4 md:mr-0"
                onClick={(e) => toggleTooltip(2, e)}
                width="20px"
                height="20px"
              >
                <g id="Info-icon" transform="translate(0.1 0.1)">
                  <path
                    id="Icon_metro-info"
                    data-name="Icon metro-info"
                    d="M11.321,7.866a.94.94,0,0,1,.938-.937h.625a.94.94,0,0,1,.937.938v.625a.94.94,0,0,1-.937.938h-.625a.94.94,0,0,1-.938-.937Zm3.75,9.063h-5v-1.25h1.25v-3.75h-1.25v-1.25h3.75v5h1.25Zm-2.5-15a10,10,0,1,0,10,10,10,10,0,0,0-10-10Zm0,18.125A8.125,8.125,0,1,1,20.7,11.928,8.125,8.125,0,0,1,12.571,20.053Z"
                    transform="translate(-2.571 -1.928)"
                    fill="#415779"
                    stroke="#fff"
                    stroke-width="0.2"
                  />
                </g>{" "}
              </svg>
            </th>
            <td className="md:px-6 py-4">
              <img
                src={percentageIcon}
                width={15}
                className="ml-5 mr-4 md:mx-auto"
                alt="percentage icon"
              />
            </td>
            <td className="md:px-6 py-4">
              <svg
                className="ml-5 mr-4 md:mx-auto"
                fill="#1f7672"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22.476 20"
                width="18px"
                height="18px"
              >
                <g id="Group_2813" data-name="Group 2813">
                  <path
                    id="Path_8102"
                    data-name="Path 8102"
                    d="M25.488,8.983l-9.443,12.49L11.973,16.2a2.5,2.5,0,1,0-3.947,3.073l6.07,7.769a2.506,2.506,0,0,0,3.947-.025L29.46,12.031a2.513,2.513,0,1,0-4-3.048Z"
                    transform="translate(-7.499 -7.994)"
                    fill="#1f7672"
                  />
                </g>{" "}
              </svg>
            </td>
          </tr>
          <tr className="odd:bg-white even:bg-[#f8fbf9] rounded">
            <th
              scope="row"
              className="md:px-6 py-4 relative flex justify-between md:w-[265px] mx-auto font-medium text-[16px] md:text-dbase text-doctio-dark whitespace-nowrap w-full"
            >
              Del fraser
              <div
                className={`tooltip-content ${
                  showTooltips[3] ? "" : "hidden"
                } absolute md:right-[-44.5rem] z-50 overflow-wrap break-word whitespace-normal h-fit text-doctio-dark w-[calc(100vw-29px)] md:w-[435px] rounded-2xl top-[35px] md:top-0 bg-white p-2 shadow-md border border-gray-300`}
              >
                <p className="m-0">
                  Via et link kan en frase eller en mappe med fraser deles med
                  kollegaer, Kopier linket og sende det i en besked.{" "}
                </p>
              </div>
              <svg
                fill="#415779"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20.2 20.2"
                className="info-boks cursor-pointer mr-4 md:mr-0"
                width="20px"
                height="20px"
                onClick={(e) => toggleTooltip(3, e)}
              >
                <g id="Info-icon" transform="translate(0.1 0.1)">
                  <path
                    id="Icon_metro-info"
                    data-name="Icon metro-info"
                    d="M11.321,7.866a.94.94,0,0,1,.938-.937h.625a.94.94,0,0,1,.937.938v.625a.94.94,0,0,1-.937.938h-.625a.94.94,0,0,1-.938-.937Zm3.75,9.063h-5v-1.25h1.25v-3.75h-1.25v-1.25h3.75v5h1.25Zm-2.5-15a10,10,0,1,0,10,10,10,10,0,0,0-10-10Zm0,18.125A8.125,8.125,0,1,1,20.7,11.928,8.125,8.125,0,0,1,12.571,20.053Z"
                    transform="translate(-2.571 -1.928)"
                    fill="#415779"
                    stroke="#fff"
                    stroke-width="0.2"
                  />
                </g>{" "}
              </svg>
            </th>
            <td className="md:px-6 py-4">
              <img
                src={percentageIcon}
                width={15}
                className="ml-5 mr-4 md:mx-auto"
                alt="percentage icon"
              />
            </td>
            <td className="md:px-6 py-4">
              <svg
                className="ml-5 mr-4 md:mx-auto"
                fill="#1f7672"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22.476 20"
                width="18px"
                height="18px"
              >
                <g id="Group_2813" data-name="Group 2813">
                  <path
                    id="Path_8102"
                    data-name="Path 8102"
                    d="M25.488,8.983l-9.443,12.49L11.973,16.2a2.5,2.5,0,1,0-3.947,3.073l6.07,7.769a2.506,2.506,0,0,0,3.947-.025L29.46,12.031a2.513,2.513,0,1,0-4-3.048Z"
                    transform="translate(-7.499 -7.994)"
                    fill="#1f7672"
                  />
                </g>{" "}
              </svg>
            </td>
          </tr>
          <tr className="odd:bg-white even:bg-[#f8fbf9] rounded">
            <th
              scope="row"
              className="md:px-6 py-4 font-medium flex w-full md:w-[265px] justify-between mx-auto text-[16px] relative md:text-dbase text-doctio-dark whitespace-nowrap w-full"
            >
              Ingen reklamer
              <div
                className={`tooltip-content ${
                  showTooltips[4] ? "" : "hidden"
                } absolute md:right-[-44.5rem] z-50 overflow-wrap break-word whitespace-normal h-fit text-doctio-dark w-[calc(100vw-29px)] md:w-[435px] rounded-2xl top-[35px] md:top-0 bg-white p-2 shadow-md border border-gray-300`}
              >
                <p className="m-0">Ingen eksponering for reklamer.</p>
              </div>
              <svg
                fill="#415779"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20.2 20.2"
                className="info-boks cursor-pointer mr-4 md:mr-0"
                onClick={(e) => toggleTooltip(4, e)}
                width="20px"
                height="20px"
              >
                <g id="Info-icon" transform="translate(0.1 0.1)">
                  <path
                    id="Icon_metro-info"
                    data-name="Icon metro-info"
                    d="M11.321,7.866a.94.94,0,0,1,.938-.937h.625a.94.94,0,0,1,.937.938v.625a.94.94,0,0,1-.937.938h-.625a.94.94,0,0,1-.938-.937Zm3.75,9.063h-5v-1.25h1.25v-3.75h-1.25v-1.25h3.75v5h1.25Zm-2.5-15a10,10,0,1,0,10,10,10,10,0,0,0-10-10Zm0,18.125A8.125,8.125,0,1,1,20.7,11.928,8.125,8.125,0,0,1,12.571,20.053Z"
                    transform="translate(-2.571 -1.928)"
                    fill="#415779"
                    stroke="#fff"
                    stroke-width="0.2"
                  />
                </g>{" "}
              </svg>
            </th>
            <td className="md:px-6 py-4">
              <img
                src={percentageIcon}
                width={15}
                className="ml-5 mr-4 md:mx-auto"
                alt="percentage icon"
              />
            </td>
            <td className="md:px-6 py-4">
              <svg
                className="ml-5 mr-4 md:mx-auto"
                fill="#1f7672"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22.476 20"
                width="18px"
                height="18px"
              >
                <g id="Group_2813" data-name="Group 2813">
                  <path
                    id="Path_8102"
                    data-name="Path 8102"
                    d="M25.488,8.983l-9.443,12.49L11.973,16.2a2.5,2.5,0,1,0-3.947,3.073l6.07,7.769a2.506,2.506,0,0,0,3.947-.025L29.46,12.031a2.513,2.513,0,1,0-4-3.048Z"
                    transform="translate(-7.499 -7.994)"
                    fill="#1f7672"
                  />
                </g>{" "}
              </svg>
            </td>
          </tr>
          <tr className="odd:bg-white even:bg-[#f8fbf9] rounded">
            <th
              scope="row"
              className="md:px-6 py-4 font-medium flex w-full md:w-[265px] justify-between relative mx-auto text-[16px] md:text-dbase text-doctio-dark whitespace-nowrap w-full"
            >
              Vis/skjul-afsnit
              <div
                className={`tooltip-content ${
                  showTooltips[5] ? "" : "hidden"
                } absolute md:right-[-44.5rem] z-50 overflow-wrap break-word whitespace-normal h-fit text-doctio-dark w-[calc(100vw-29px)] md:w-[435px] rounded-2xl top-[35px] md:top-0 bg-white p-2 shadow-md border border-gray-300`}
              >
                <p className="m-0">
                  Mulighed for at toggle afsnit til og fra, således afsnittene
                  vises eller skjules.{" "}
                </p>
              </div>
              <svg
                fill="#415779"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20.2 20.2"
                className="info-boks cursor-pointer mr-4 md:mr-0"
                onClick={(e) => toggleTooltip(5, e)}
                width="20px"
                height="20px"
              >
                <g id="Info-icon" transform="translate(0.1 0.1)">
                  <path
                    id="Icon_metro-info"
                    data-name="Icon metro-info"
                    d="M11.321,7.866a.94.94,0,0,1,.938-.937h.625a.94.94,0,0,1,.937.938v.625a.94.94,0,0,1-.937.938h-.625a.94.94,0,0,1-.938-.937Zm3.75,9.063h-5v-1.25h1.25v-3.75h-1.25v-1.25h3.75v5h1.25Zm-2.5-15a10,10,0,1,0,10,10,10,10,0,0,0-10-10Zm0,18.125A8.125,8.125,0,1,1,20.7,11.928,8.125,8.125,0,0,1,12.571,20.053Z"
                    transform="translate(-2.571 -1.928)"
                    fill="#415779"
                    stroke="#fff"
                    stroke-width="0.2"
                  />
                </g>{" "}
              </svg>
            </th>
            <td className="md:px-6 py-4">
              <img
                src={percentageIcon}
                width={15}
                className="ml-5 mr-4 md:mx-auto"
                alt="percentage icon"
              />
            </td>
            <td className="md:px-6 py-4">
              <svg
                className="ml-5 mr-4 md:mx-auto"
                fill="#1f7672"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22.476 20"
                width="18px"
                height="18px"
              >
                <g id="Group_2813" data-name="Group 2813">
                  <path
                    id="Path_8102"
                    data-name="Path 8102"
                    d="M25.488,8.983l-9.443,12.49L11.973,16.2a2.5,2.5,0,1,0-3.947,3.073l6.07,7.769a2.506,2.506,0,0,0,3.947-.025L29.46,12.031a2.513,2.513,0,1,0-4-3.048Z"
                    transform="translate(-7.499 -7.994)"
                    fill="#1f7672"
                  />
                </g>{" "}
              </svg>
            </td>
          </tr>

          <tr className="odd:bg-white even:bg-[#f8fbf9] rounded">
            <th
              scope="row"
              className="md:px-6 py-4 font-medium flex relative md:w-[265px] justify-between mx-auto text-[16px] md:text-dbase text-doctio-dark whitespace-nowrap w-full"
            >
              Logikfunktion
              <div
                className={`tooltip-content ${
                  showTooltips[6] ? "" : "hidden"
                } absolute md:right-[-44.5rem] z-50 overflow-wrap break-word whitespace-normal h-fit text-doctio-dark w-[calc(100vw-29px)] md:w-[435px] rounded-2xl top-[35px] md:top-0 bg-white p-2 shadow-md border border-gray-300`}
              >
                <p className="m-0">
                  Logikfunktion tillader automatisk udfyldning af klikelementer
                  ud fra værdier der indtastes løbende gennem en frase.{" "}
                </p>
              </div>
              <svg
                fill="#415779"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20.2 20.2"
                onClick={(e) => toggleTooltip(6, e)}
                className="info-boks cursor-pointer mr-4 md:mr-0"
                width="20px"
                height="20px"
              >
                <g id="Info-icon" transform="translate(0.1 0.1)">
                  <path
                    id="Icon_metro-info"
                    data-name="Icon metro-info"
                    d="M11.321,7.866a.94.94,0,0,1,.938-.937h.625a.94.94,0,0,1,.937.938v.625a.94.94,0,0,1-.937.938h-.625a.94.94,0,0,1-.938-.937Zm3.75,9.063h-5v-1.25h1.25v-3.75h-1.25v-1.25h3.75v5h1.25Zm-2.5-15a10,10,0,1,0,10,10,10,10,0,0,0-10-10Zm0,18.125A8.125,8.125,0,1,1,20.7,11.928,8.125,8.125,0,0,1,12.571,20.053Z"
                    transform="translate(-2.571 -1.928)"
                    fill="#415779"
                    stroke="#fff"
                    stroke-width="0.2"
                  />
                </g>{" "}
              </svg>
            </th>
            <td className="md:px-6 py-4">
              <img
                src={percentageIcon}
                width={15}
                className="ml-5 mr-4 md:mx-auto"
                alt="percentage icon"
              />
            </td>
            <td className="md:px-6 py-4">
              <svg
                className="ml-5 mr-4 md:mx-auto"
                fill="#1f7672"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22.476 20"
                width="18px"
                height="18px"
              >
                <g id="Group_2813" data-name="Group 2813">
                  <path
                    id="Path_8102"
                    data-name="Path 8102"
                    d="M25.488,8.983l-9.443,12.49L11.973,16.2a2.5,2.5,0,1,0-3.947,3.073l6.07,7.769a2.506,2.506,0,0,0,3.947-.025L29.46,12.031a2.513,2.513,0,1,0-4-3.048Z"
                    transform="translate(-7.499 -7.994)"
                    fill="#1f7672"
                  />
                </g>{" "}
              </svg>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
